<template>
  <img
    :src="avatar"
    class="avatar"
    @click="toggleUserWindow"
    :style="{ height, width }"
  />
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: "32px"
    },
    width: {
      type: String,
      default: "32px"
    }
  },

  computed: {
    avatar() {
      return this.$store.getters.currentUserImage;
    }
  },
  methods: {
    toggleUserWindow() {
      this.$emit("toggleUser");
    }
  }
};
</script>

<style scoped>
.avatar {
  border-radius: 100%;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/NavBar/UserAvatar.vue